import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

export default function Loader({ className }) {
  return (
    <FontAwesomeIcon className={`${className} animate-spin`} icon={faSpinner} />
  );
}
